import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { globals } from '../globals';
import { CRMHierarquiaUsuario } from '../models/crmhierarquia-usuario';

@Injectable({
  providedIn: 'root'
})
export class CRMHierarquiaUsuarioService {

  constructor(private http: HttpClient) {

  }

  usuarioDentroDaHierarquia() {
    return this.http.get<any>(globals.apiUrl + '/api/CRMHierarquiaUsuario/UsuarioDentroDaHierarquia');
  }

  consultarHierarquiaDoUsuario() {
    return this.http.get<any>(globals.apiUrl + '/api/CRMHierarquiaUsuario/buscarHierarquiaDoUsuario');
  }

  consultarHierarquiaDoUsuarioLista(idFuncionario?, somenteLideres?, somenteAtivos?, todos?) {

    let parametros = new HttpParams();
    if (somenteAtivos !== undefined && somenteAtivos !== null) {
      parametros = parametros.set('somenteAtivos', somenteAtivos);
    }

    if (idFuncionario && idFuncionario !== null) {
      return this.http.get<any>(globals.apiUrl + '/api/CRMHierarquiaUsuario/buscarHierarquiaDoUsuarioListaInclusive',
        { params: parametros.set('idFuncionario', idFuncionario).set('somenteLideres', somenteLideres === undefined || somenteLideres === null ? 'false' : somenteLideres) });
    } else {
      return this.http.get<any>(globals.apiUrl + '/api/CRMHierarquiaUsuario/buscarHierarquiaDoUsuarioLista',
        {
          params: parametros.set('somenteLideres', somenteLideres === undefined || somenteLideres === null ? 'false' : somenteLideres).
            set('todos', todos === undefined || todos === null ? 'false' : todos)
        });
    }
  }

  consultar() {
    return this.http.get<any>(globals.apiUrl + '/api/CRMHierarquiaUsuario/Buscar');
  }

  salvar(hierarquia: CRMHierarquiaUsuario) {
    return this.http.post(globals.apiUrl + '/api/CRMHierarquiaUsuario/Salvar', hierarquia ? hierarquia : {});
  }

  podeExcluirUsuarioDaHierarquia(id) {
    return this.http.get<any>(globals.apiUrl + '/api/CRMHierarquiaUsuario/PodeExcluirUsuarioDaHierarquia',
      { params: new HttpParams().set('id', id) });
  }

  superiorOuIgual(idUsuario) {
    return this.http.get<any>(globals.apiUrl + '/api/CRMHierarquiaUsuario/SuperiorOuIgual',
      { params: new HttpParams().set('idUsuario', idUsuario) });
  }

  buscarSuperior(idUsuario) {
    return this.http.get<any>(globals.apiUrl + '/api/CRMHierarquiaUsuario/BuscarSuperior',
      { params: new HttpParams().set('idUsuario', idUsuario) });
  }
}
